import { useEffect, useState } from 'react';
import Lightbox from '../components/Lightbox.jsx';
import Loader from '../components/Loader.jsx';
import NoiseOverlay from '../components/NoiseOverlay.jsx';
import Wordmark from '../components/Wordmark.jsx';
import { useGalleryImages } from '../hooks/useGalleryImages.js';
import { useSmoothScroll } from '../hooks/useSmoothScroll.js';
import About from '../sections/About.jsx';
import ContactFooter from '../sections/ContactFooter.jsx';
import Hero from '../sections/Hero.jsx';
import Manifesto from '../sections/Manifesto.jsx';
import VisualStream from '../sections/VisualStream.jsx';
import { buildStoryLayout, createSessionSeed } from '../utils/galleryLayout.js';

export default function Home() {
  const { images, loading, error } = useGalleryImages();
  const [seed, setSeed] = useState('');
  const [focusedImage, setFocusedImage] = useState(null);

  useSmoothScroll(!loading && !error);

  useEffect(() => {
    if (images.length && !seed) setSeed(createSessionSeed(images));
  }, [images, seed]);

  if (loading) return <Loader />;
  if (error) return <Loader error={error} />;

  const story = buildStoryLayout(images, seed || 'initial');

  return (
    <main className="site-shell">
      <NoiseOverlay />
      <header className="site-nav" aria-label="Hauptnavigation">
        <Wordmark compact />
        <nav>
          <a href="#work">Work</a>
          <a href="#about">About</a>
          <a href="#contact">Inquiry</a>
          <a href="/admin">Admin</a>
        </nav>
      </header>
      <Hero images={story.slice(0, 7)} />
      <Manifesto />
      <VisualStream images={story} onFocusImage={setFocusedImage} />
      <About />
      <ContactFooter />
      <Lightbox image={focusedImage} images={story} onClose={() => setFocusedImage(null)} onSelect={setFocusedImage} />
    </main>
  );
}
